import { render, staticRenderFns } from "./CentroCustoFilterBar.vue?vue&type=template&id=38f51a70"
import script from "./CentroCustoFilterBar.vue?vue&type=script&lang=js"
export * from "./CentroCustoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports